import { useEffect, useState, type CSSProperties } from 'react';

import demera from './assets/demera.svg';
import styles from './MeskelBrand.module.css';

/** The app bar removes this treatment when the exclusive campaign ends. */
export function MeskelBrand({ paused }: { paused: boolean }) {
  const [pageHidden, setPageHidden] = useState(() => document.hidden);

  useEffect(() => {
    const update = () => setPageHidden(document.hidden);
    document.addEventListener('visibilitychange', update);
    return () => document.removeEventListener('visibilitychange', update);
  }, []);

  return (
    <span
      className={styles.reveal}
      style={{ '--meskel-play-state': paused || pageHidden ? 'paused' : 'running' } as CSSProperties}
    >
      {/* One stable accessible title, without repeated live announcements. */}
      <span className={styles.accessible}>YeneShop — <span lang="am">መልካም የመስቀል በዓል!</span></span>
      {/* Each track takes its text's natural width. The artwork therefore
          stops at the final letter, including after a font or viewport change. */}
      <span className={styles.track} aria-hidden="true">
        <span className={styles.brand}>YeneShop</span>
        <span className={styles.introDemera}><img src={demera} alt="" /></span>
        <span className={styles.returnDemera}><img src={demera} alt="" /></span>
      </span>
      <span className={styles.track} aria-hidden="true">
        <span className={styles.greeting} lang="am">መልካም የመስቀል በዓል!</span>
        <span className={styles.greetingDemera}><img src={demera} alt="" /></span>
      </span>
    </span>
  );
}
